import { push } from 'react-router-redux';
import Cookies from 'js-cookie';

import forceLogoutHandler from '../users/a.users.forceLogoutHandler';

import {

} from '../actions.export'

////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////
// Get a specific component version to demo
////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////

export const requestGetComponentVersionToDemo = packet => {
  return {
    type: 'REQUEST_GET_COMPONENT_VERSION_TO_DEMO',
    data: {
      lastSubmit: packet
    }
  }
}

export const receiveGetComponentVersionToDemoSuccess = data => ({
  type: 'RECEIVE_GET_COMPONENT_VERSION_TO_DEMO_SUCCESS',
  data
})

export const receiveGetComponentVersionToDemoFail = data => ({
  type: 'RECEIVE_GET_COMPONENT_VERSION_TO_DEMO_FAIL',
  data
})

export const tryToGetComponentVersionToDemo = packet => (dispatch, getState) => {

  dispatch(requestGetComponentVersionToDemo(packet));

  let headers = {
    "Content-Type": "application/json"
  }
  


  let fs = localStorage.getItem(process.env.REACT_APP_COOKIE_FEATURE_SWITCH);
  if(fs){
    headers["X-NFS"] = fs;
  }


  headers["X-CSRF-TOKEN"] = getState().userReducer.csrf_token; 

  let demoAuth = Cookies.get(process.env.REACT_APP_COOKIE_DEMO_AUTH)
  if(demoAuth){
    headers["X-demo-auth"] = demoAuth;
  }

  return fetch('/api/components/public/demo/' + packet.id + '/' + packet.version, {
      method: 'get',
      headers: headers
    })
    .then((response) => {
      let json = response.json();
      if (response.status >= 200 && response.status < 300) return json;
      return json.then(Promise.reject.bind(Promise));
    })
    .then(function(json){
      dispatch(receiveGetComponentVersionToDemoSuccess(json));
    })
    .catch(e => {
      dispatch(forceLogoutHandler(e));
      dispatch(receiveGetComponentVersionToDemoFail({errors:e, lastSubmit: packet}));
      
      // send the user to the error page
      dispatch(push('/oops'));
    })
}
